import React, { useState, useRef, useEffect } from "react";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
} from "react-image-crop";
import { canvasPreview } from "./canvasPreview";
import { useDebounceEffect } from "./useDebounceEffect";
import "react-image-crop/dist/ReactCrop.css";
import { SketchPicker } from "react-color";
import { HerotSaveSourceImage, HerotSaveToken, HerotGetImageData, HerotGetAiData, GetInitialData, HerotSaveCustomBorder, GetInitialBorders, UpdateCustomBorderOffset } from "./process"; // Shomen
import { FastAverageColor } from "fast-average-color";

// This is to demonstrate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
// This determines the initital size of the crop selector
function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "px",
        width: 300,
        height: 300,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}


export default function App() {
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const hiddenAnchorRef = useRef<HTMLAnchorElement>(null);
  const blobUrlRef = useRef("");
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState(1);
  const [percentCrop, setPercentCrop] = useState<Crop>();
  const [ruleOfThirds, setRuleOfThirds] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const colorDropdownContainer = useRef<HTMLDivElement>(null);
  const borderDropdownContainer = useRef<HTMLDivElement>(null);
  const settingsDropdownContainer = useRef<HTMLDivElement>(null);
  const zoomDropdownContainer = useRef<HTMLDivElement>(null);
  const [hoverHorizontalMovePercentage, setHoverHorizontalMovePercentage] = useState<any>(null);
  const [hoverVerticalMovePercentage, setHoverVerticalMovePercentage] = useState<any>(null);
  const [borderSearchTerm, setBorderSearchTerm] = useState('');
  const [isSaveButtonDisabled, setSaveButtonDisabled] = useState(false);
  const [isGoProPopupOpen, setIsGoProPopupOpen] = useState(false);
  const [isRegisterPopupOpen, setIsRegisterPopupOpen] = useState(false);
  const isMobile = window.innerWidth <= 768;
  const backgroundColorInputRef = useRef<HTMLInputElement | null>(null);

  const startSources = ["elf-min.webp", "darkelf-min.webp", "warrior-min.webp"]
  const startOverlays = ["leaves834.webp", "evil822.webp", "woodnails849.webp"];
  const startOffset = [0.86, 0.78, 0.86];
  const startHoverOffset = [0.86, 0.78, 0.86];
  const herotRandomStart = Math.floor(Math.random() * startOverlays.length);
  const [overlaySrc, setOverlaySrc] = useState(
    localStorage.getItem('heroImgId')
      ? '/wp-content/heroictoken/borders/transparent.webp'
      : `/wp-content/heroictoken/borders/${startOverlays[herotRandomStart]}`
  );
  const [hoverOverlaySrc, setHoverOverlaySrc] = useState<string | null>(overlaySrc);
  const [image_url, setImageUrl] = useState(null);
  const [horizontalMovePercentage, setHorizontalMovePercentage] = useState(0);
  const [verticalMovePercentage, setVerticalMovePercentage] = useState(0);

  // Variables that we need for saving the second step of the process
  const [imgSrc, setImgSrc] = useState(
    localStorage.getItem('heroImgId') ? '' : `/wp-content/heroictoken/icons/${startSources[herotRandomStart]}`
  );
  const [crop, setCrop] = useState<Crop>();
  const [scale, setScale] = useState(0.7);
  const [offset, setOffset] = useState(
    localStorage.getItem('heroImgId')
      ? 1
      : Number(startOffset[herotRandomStart].toFixed(2))
  );

  const [hoverOffset, setHoverOffset] = useState(
    localStorage.getItem('heroImgId')
      ? 1
      : Number(startOffset[herotRandomStart].toFixed(2))
  );
  const [herotFilterColor, setHerotFilterColor] = useState({ r: 0, g: 0, b: 0 });
  const [herotFilterTransp, setHerotFilterTransp] = useState(0.2);
  const [herotFilterActive, setHerotFilterActive] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState<string | null>();
  const [tokenName, setTokenName] = useState("");
  const [tokenSize, setTokenSize] = useState(400);
  const [backgroundColor, setBackgroundColor] = useState('#808080');

  /**Start Shomen*/
  const [curUser, setCurUser] = useState(''); // State for the user id - if they logged in 
  const [uploadedImageFile, setUploadedImageFile] = useState<any>([]); // new
  const [curSourceId, setCurSourceId] = useState<any>();
  const [curTokenId, setCurTokenId] = useState<any>();
  const [classDisable, setClassDisable] = useState('herot-disable'); // new
  const [htLoadingScreen, setHtLoadingScreen] = useState(false); // new
  const [apiMessage, setApiMessage] = useState('');
  const [remainingCredits, setRemainingCredits] = useState(0);
  const [prompt, setPrompt] = useState(""); // New state variable for the prompt
  const [aiGenLoad, setAiGenLoad] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [currentBorderId, setCurrentBorderId] = useState(0);
  const [isCustomBorder, setIsCustomBorder] = useState('');
  const [curBorderTab, setCurBorderTab] = useState('fantasy');
  const [borderSaveMsg, setBorderSaveMsg] = useState('');
  const [htFullLoadingScreen, setHtFullLoadingScreen] = useState(false); // new
  const [allCustomBorders, setAllCustomBorders] = useState([]);
  const [htPrvImage, setHtPrvImage] = useState<any>();
  /**End Shomen*/

  interface Overlay {
    image: string;
    offset: number;
    search: string;
    pro: boolean;
    horizontalmove: number;
    verticalmove: number;
    category: Array<any>;
  }

  interface TokenOverlays {
    overlays: Overlay[];
  }

  interface AppProps {
    tokenOverlays: TokenOverlays;
  }

  const tokenOverlays: TokenOverlays = require('./wp-content/heroictoken/borders/tokenOverlays.json');

  /**Start Shomen*/
  React.useEffect(() => {
    const curUserid = document.getElementById("herotuserid") as HTMLInputElement;
    if (process.env.NODE_ENV !== 'production') {
      //console.log('Dev.......');
    }
    else {
      if (curUserid !== null) {
        setCurUser(curUserid.value); // Setting up the user id for the login user

        const gettData = new Promise((resolve, reject) => {
          resolve(GetInitialData(curUser));
        });

        gettData.then((value: any) => {
          if (value.status == '200') {
            setRemainingCredits(value.credits);
            setApiMessage('');
          } else if (value.status == '404') {
            setRemainingCredits(value.credits);
            setApiMessage(value.message);
          }

        });

        const gettBorderData = new Promise((resolve, reject) => {
          resolve(GetInitialBorders(curUser));
        });

        gettBorderData.then((value: any) => {
          if (value.status == '200') {
            setAllCustomBorders(value.borders);
          } else if (value.status == '424') {
            console.log(value.message);
          } else {
            console.log('Error..');
          }

        });

        //(curUser);
        //console.log('logged in.......');
      } else {
        //console.log('Its null');
      }

    }

    if (localStorage.getItem('heroImgId')) {
      setHtLoadingScreen(true);
      var newtext = localStorage.getItem('heroImgId');
      if (newtext) {
        const gettData = new Promise((resolve, reject) => {
          resolve(HerotGetImageData(localStorage.getItem('heroImgId'), localStorage.getItem('heroImgCat'), curUser));
        });

        gettData.then((value: any) => {
          const img = new Image();
          img.onload = () => {
            htDrawimg(value.imgdata);
            setImgSrc(value.imgdata);
            setCurSourceId(value.imgid);
            localStorage.setItem('heroImgCat', '');
            localStorage.setItem('heroImgId', '');
            setClassDisable('');
            setHtLoadingScreen(false);
          };
          img.src = value.imgdata;
        });

      }
    }

  }, [curUser]);

  // if(uploadedImageFile){
  //   setClassDisable('');
  // }else{
  //   setClassDisable('herot-disable');
  // }

  async function saveCroppedImage() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error("Crop canvas does not exist");
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      tokenSize, tokenSize
    );
    const ctx = offscreen.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }

    // This is the image that is exported
    ctx.drawImage(
      previewCanvas,
      0,
      0,
      // This is the size of the clipped image
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      // This is the size of the exported image
      tokenSize,
      tokenSize,
    );

    // You might want { type: "image/jpeg", quality: <0 to 1> } to 
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: "image/png",
    });

    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }
    blobUrlRef.current = URL.createObjectURL(blob);

    setClassDisable('herot-disable');
    const reader = new FileReader();
    reader.addEventListener("load", () => {

      const gettData = new Promise((resolve, reject) => {
        resolve(HerotSaveToken(reader.result?.toString() || "", curSourceId, 'image/png', tokenName ? tokenName : 'notitle', JSON.stringify(herotFilterColor), curUser));
      });

      gettData.then((value: any) => {
        setCurTokenId(value.tokenid);
        //console.log(value.tokenid);
        setClassDisable('');
      });
    }
    );
    reader.readAsDataURL(blob);

  }

  const viewMainSitePopUp = () => {
    const mainPopup = document.getElementById('herot-user-saved-data-pop') as HTMLElement;
    if (mainPopup !== null) {
      mainPopup.style.display = 'block';
      const loadData = document.getElementById("herot-user-panel-load-inp") as HTMLInputElement;
      if (loadData !== null) {
        loadData.click();
      }
      else {
        const loadDataNotLog = document.getElementById("herot-user-panel-load-not-log") as HTMLInputElement;
        if (loadDataNotLog !== null) {
          loadDataNotLog.click();
        }
      }
    }
  }

  function htDrawimg(idata: any) {
    var img = new Image();
    img.onload = (img.src, function () {
      var cvas = document.createElement('canvas');
      cvas.width = 40;
      cvas.height = 40;
      const ctx = cvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, 40, 40, 0, 0, 40, 40);

      const fac = new FastAverageColor();
      const htimage = new Image();
      // htimage.crossOrigin = 'Anonymous';
      htimage.src = cvas.toDataURL("image/jpeg", 1.0);
      fac.getColorAsync(htimage)
        .then(color => {
          setBackgroundColor(color.rgba);
          // container.style.backgroundColor = color.rgba;
          // container.style.color = color.isDark ? '#fff' : '#000';
        });
    });
    img.src = idata;
  }

  function htUploadBorder(e: any) {
    //console.log('Inn.....');
    if (e.files && e.files.length > 0) {
      let curImgName: string | undefined = e.files[0].name;

      let extension = curImgName?.split(".")?.pop()?.toUpperCase();
      if (extension != "PNG" &&
        extension != "WEBP") {
        alert('Please upload your border in a format that allows transparency.')
      } else {
        setHtFullLoadingScreen(true); // Need to set new load screen
        const reader = new FileReader();
        let bOffset = .9;
        let bShape = 'round';
        let bImgPro = 'false';

        reader.addEventListener("load", (u) => {
          // //console.log(reader.result?.toString() || "");
          const gettData = new Promise((resolve, reject) => {
            if (!e.files) return;
            resolve(HerotSaveCustomBorder(reader.result?.toString() || "", e.files[0].type, bOffset, bImgPro, bShape, curUser));
          });
          gettData.then((value: any) => {
            setBorderSaveMsg(value.message);
            setHtFullLoadingScreen(false);


            const gettBorderData = new Promise((resolve, reject) => {
              resolve(GetInitialBorders(curUser));
            });

            gettBorderData.then((value: any) => {
              if (value.status == '200') {
                setAllCustomBorders(value.borders);
                //console.log('Load after save');    
              } else if (value.status == '424') {
                console.log(value.message);
              } else {
                console.log('Error..');
              }

            });

          });

        }

        );
        reader.readAsDataURL(e.files[0]);
      } // End file check
    }
  }

  function htUpdateBorderOffset() {
    let curBorderId = currentBorderId;
    let curOffset = offset;
    if (curBorderTab == 'custom') {
      if (curBorderId && curOffset) {
        setHtFullLoadingScreen(true);
        const gettBorderData = new Promise((resolve, reject) => {
          resolve(UpdateCustomBorderOffset(curUser, curBorderId, curOffset, horizontalMovePercentage, verticalMovePercentage));
        });

        gettBorderData.then((value: any) => {
          setHtFullLoadingScreen(false);
          if (value.status == '200') {
            setBorderSaveMsg(value.message);

            const gettBorders = new Promise((resolve, reject) => {
              resolve(GetInitialBorders(curUser));
            });

            gettBorders.then((value: any) => {
              if (value.status == '200') {
                setAllCustomBorders(value.borders);
                //console.log('Load after save');    
              } else if (value.status == '424') {
                console.log(value.message);
              } else {
                console.log('Error..');
              }

            });

            //console.log('Load after save');    
          } else if (value.status == '424') {
            console.log(value.message);
          } else {
            console.log('Error..');
          }

        });
      } else {
        alert('Select a custom border and try again');
      }
    }
  }

  function setCurrentOffset(e: any) {
    if (e.target.value) {
      //console.log('CurVal - '+Number(e.target.value));
      if (isCustomBorder == 'yes') {
        setOverlaySrc(overlaySrc);
        setHoverOffset(Number(e.target.value));
        setOffset(Number(e.target.value));
      }
    }
  }

  function onUploadBorder(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      let curImgName: string | undefined = e.target.files[0].name;

      let extension = curImgName?.split(".")?.pop()?.toUpperCase();
      if (extension != "PNG" &&
        extension != "WEBP") {
        alert('Please upload your border in a format that allows transparency.')
      } else {
        setHtPrvImage(URL.createObjectURL(e.target.files[0]));
        if (!curUser) {
          setHoverOverlaySrc(URL.createObjectURL(e.target.files[0]));
          setHoverOffset(offset);
          setIsCustomBorder('yes');
        }

      }
    }
  }

  /**End Shomen*/

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      let curImgName: string | undefined = e.target.files[0].name;

      let extension = curImgName?.split(".")?.pop()?.toUpperCase();
      if (extension != "PNG" &&
        extension != "JPG" &&
        extension != "JPEG" &&
        extension != "WEBP") {
        alert("Please upload a 'PNG', 'JPG', 'JPEG' or 'WEBP' type image")
      } else {
        setUploadedImageFile(e.target.files[0]); // Shomen

        setCrop(undefined); // Makes crop preview update between images.
        const reader = new FileReader();

        /**Start Shomen*/
        reader.addEventListener("load", (u) => {
          //** Process image for background color */
          htDrawimg(u.target?.result);
          setImgSrc(reader.result?.toString() || "");

          const gettData = new Promise((resolve, reject) => {
            if (!e.target.files) return;
            resolve(HerotSaveSourceImage(reader.result?.toString() || "", e.target.files[0].type, 'notitle', curUser));
          });
          gettData.then((value: any) => {
            setCurSourceId(value.sourceid);
            //console.log(value.sourceid);
            setClassDisable('');
          });
        }
          /**End Shomen*/
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  }
  const generalInput = "Follow this prompt exactly: Colored frontal painterly portrait of head and shoulders of a single rpg character on an absolutely white background";
  const [backgroundDescription] = "Make the whole background of the portrait pure white. Do not show brands. Do not show watermarks.";
  const generalAppendix = " Make the space above the head pure white. The portrait has diffuse Lighting: Light that is evenly distributed across the scene, reducing shadows.";


  const imageGenerator = async () => {
    if (inputValue === "") {
      return 0;
    } else {
      setAiGenLoad(true);
      setHtLoadingScreen(true);
      // Append the descriptions to the inputValue
      const promptText = `${generalInput}. The person has the following attributes: ${inputValue}. ${backgroundDescription}${generalAppendix}`;
      setPrompt(promptText);
      const gettData = new Promise((resolve, reject) => {
        resolve(HerotGetAiData(promptText, inputValue, curUser));
      });

      gettData.then((value: any) => {
        if (value.status == '200') {
          htDrawimg(value.imgdata);
          setImgSrc(value.imgdata);
          setCurSourceId(value.imgid);
          setImageUrl(value.imgurl);

          setRemainingCredits(value.remaincredits);
        } else if (value.status == 'apierror') {
          setApiMessage(value.apimessage);
        } else if (value.status == 'expire') {
          setRemainingCredits(value.remaincredits);
          setApiMessage(value.creditmessage);
        }
        setHtLoadingScreen(false);
        setAiGenLoad(false);
      });
    }

  }


  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const imgElement = e.currentTarget;
    const { width, height } = imgElement;
    const img = new Image();
    img.onload = function () {
      // Check if the image is fully loaded
      if (img.complete) {
        const { naturalWidth: modifierWidth, naturalHeight: modifierHeight } = img;
        let positionmodifier = modifierHeight / modifierWidth * 6;

        let initialCrop;

        // If the height is not larger than the width
        if (modifierHeight <= modifierWidth) {
          initialCrop = centerAspectCrop(width, height, aspect);
        } else {
          // If the height is larger than the width
          if (window.innerWidth <= 600) { // If on a mobile device
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            initialCrop = centerAspectCrop(viewportWidth, viewportHeight, aspect);
            initialCrop.y = viewportHeight / positionmodifier; // Position at the upper fourth
          } else { // If on a desktop device
            initialCrop = centerAspectCrop(width, height, aspect);
            initialCrop.y = height / positionmodifier; // Position at the upper fourth
          }
        }

        // Set the crop values immediately after calculating them
        setCrop(initialCrop);
      }
    };
    img.src = imgElement.src;
  }

  async function onDownloadCropClick() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error("Crop canvas does not exist");
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      tokenSize, tokenSize
    );
    const ctx = offscreen.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }

    // This is the image that is exported
    ctx.drawImage(
      previewCanvas,
      0,
      0,
      // This is the size of the clipped image
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      // This is the size of the exported image
      tokenSize,
      tokenSize,
    );

    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: "image/png",
    });

    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }
    blobUrlRef.current = URL.createObjectURL(blob);
    hiddenAnchorRef.current!.href = blobUrlRef.current;

    // Set the filename to tokenName if it's not empty, otherwise use a default filename
    hiddenAnchorRef.current!.download = tokenName ? `${tokenName}.png` : 'heroictoken.png';

    hiddenAnchorRef.current!.click();
  }

  const overlay = useRef(new Image());

  useEffect(() => {
    const loadImage = async () => {
      return new Promise((resolve, reject) => {
        overlay.current.src = hoverOverlaySrc !== null ? hoverOverlaySrc : overlaySrc;
        overlay.current.onload = () => resolve(null);
        overlay.current.onerror = reject;
      });
    };

    loadImage().catch((error) => console.error(`Error loading image: ${error}`));
  }, [hoverOverlaySrc, overlaySrc]);


  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
          overlay.current,
          offset,
          hoverOverlaySrc,
          hoverOffset,
          herotFilterTransp,
          `rgb(${herotFilterColor.r}, ${herotFilterColor.g}, ${herotFilterColor.b})`,
          herotFilterActive,
          backgroundColor,
          horizontalMovePercentage,
          verticalMovePercentage,
          hoverHorizontalMovePercentage,
          hoverVerticalMovePercentage,
        );
      }
    },
    100,
    [completedCrop, scale, rotate, overlay.current, hoverOverlaySrc, hoverOffset, herotFilterActive, backgroundColor, horizontalMovePercentage, verticalMovePercentage, offset],
  );

  // Add new state variables for the crop area's position and size
  const [cropPosition, setCropPosition] = useState({ x: 0, y: 0 });
  const [cropSize, setCropSize] = useState({ width: 300, height: 300 });

  // Update the overlay position and size when the crop values change
  // crop is dynamic, based on percentages
  //completedCrop has pixel values, but is only updated when dragging has en
  useEffect(() => {
    if (completedCrop && imgRef.current) {
      setCropPosition({
        x: completedCrop.x,
        y: completedCrop.y,
      });
      setCropSize({
        width: completedCrop.width,
        height: completedCrop.height,
      });
    }
  }, [completedCrop, imgRef, imgSrc, overlaySrc, herotFilterTransp, herotFilterColor]);

  useEffect(() => {
    if (imgRef.current && previewCanvasRef.current && completedCrop) {
      canvasPreview(
        imgRef.current,
        previewCanvasRef.current,
        completedCrop,
        scale,
        rotate,
        overlay.current,
        offset,
        hoverOverlaySrc,
        hoverOffset,
        herotFilterTransp,
        `rgb(${herotFilterColor.r}, ${herotFilterColor.g}, ${herotFilterColor.b})`,
        herotFilterActive,
        backgroundColor,
        horizontalMovePercentage,
        verticalMovePercentage,
        hoverHorizontalMovePercentage,
        hoverVerticalMovePercentage
      );
    }
  }, [imgRef, previewCanvasRef, completedCrop, scale, rotate, overlay.current, hoverOffset, herotFilterTransp, herotFilterColor, herotFilterActive, backgroundColor, , horizontalMovePercentage, verticalMovePercentage, offset]);

  // Closing the border picker div if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        openDropdown === 'color' &&
        colorDropdownContainer.current &&
        !colorDropdownContainer.current.contains(event.target as Node)
      ) {
        setTimeout(() => setOpenDropdown(null), 0);
      } else if (
        openDropdown === 'border' &&
        borderDropdownContainer.current &&
        !borderDropdownContainer.current.contains(event.target as Node)
      ) {
        setTimeout(() => setOpenDropdown(null), 0);
      } else if (
        openDropdown === 'zoom' &&
        zoomDropdownContainer.current &&
        !zoomDropdownContainer.current.contains(event.target as Node)
      ) {
        setTimeout(() => setOpenDropdown(null), 0);
      } else if (
        openDropdown === 'settings' &&
        settingsDropdownContainer.current &&
        !settingsDropdownContainer.current.contains(event.target as Node)
      ) {
        setTimeout(() => setOpenDropdown(null), 0);
      }
    };

    // Attach the listener to the document
    document.addEventListener('mouseup', handleClickOutside);

    // Cleanup the listener when the component unmounts
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, [openDropdown]);

  useEffect(() => {
    const overlay = new Image();
    if (overlaySrc || hoverOverlaySrc !== null) {
      overlay.src = hoverOverlaySrc !== null ? hoverOverlaySrc : overlaySrc;
      overlay.onload = () => {
        const offscreenCanvas = document.createElement('canvas');

        // Set the size of the offscreen canvas to the size of cropSize
        offscreenCanvas.width = cropSize.width;
        offscreenCanvas.height = cropSize.height;

        const offscreenCtx = offscreenCanvas.getContext('2d');

        if (!offscreenCtx) return;

        offscreenCtx.drawImage(
          overlay,
          0,
          0,
          cropSize.width,
          cropSize.height
        );

        if (herotFilterActive) {
          offscreenCtx.globalCompositeOperation = 'source-atop';

          const defaultColor = herotFilterColor;
          const defaultTransp = herotFilterTransp;

          offscreenCtx.fillStyle = `rgba(${defaultColor.r}, ${defaultColor.g}, ${defaultColor.b}, ${defaultTransp})`;

          offscreenCtx.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

          offscreenCtx.globalCompositeOperation = 'source-over';
        }

        // Convert the offscreen canvas to a data URL and set the state variable
        setOverlayImageUrl(offscreenCanvas.toDataURL());
      };
    }
  }, [herotFilterColor, herotFilterTransp, overlaySrc, hoverOverlaySrc, herotFilterActive]);

  const popupRef = useRef<HTMLDivElement>(null);

  const openRegisterPopup = () => {
    setIsRegisterPopupOpen(true);
  };

  const closeRegisterPopup = () => {
    setIsRegisterPopupOpen(false);
  };

  useEffect(() => {
    // Function to handle clicks outside of the popup
    const handleClickOutside = (event: MouseEvent) => {
      if (isRegisterPopupOpen && popupRef.current && !popupRef.current.contains(event.target as Node)) {
        closeRegisterPopup();
      }
    };

    // Add the event listener when the component mounts
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isRegisterPopupOpen, closeRegisterPopup]); // Dependency array

  const herotTutorials = [
    { title: "Short Video Overview", videoId: "2KDEHxOBMKw" },
  ];

  return (
    <div className="App" >
      { /**Start Shomen*/
        htFullLoadingScreen && (
          <div className="ht-main-loading-screen">
            <span className="ht-main-loading-spinner"></span>
          </div>
        )
      /**End Shomen*/}

      <div className="herot-crop-container-container" >
        <div className="herot-app-header">
          <div className="herot-border-button-container">
            <div className="herot-app-header-button" onClick={() => {
              setOpenDropdown(null);
              setTimeout(() => setOpenDropdown(openDropdown === 'border' ? null : 'border'), 0);
              setBorderSaveMsg('');
            }}>
              <div><img
                src="/wp-content/heroictoken/icons/border-solid.svg"
                style={{ width: '20px', height: '20px', padding: '2px' }}
                alt="circle symbol"
              /></div>
              <div>Borders</div>
            </div>
            {openDropdown === 'border' && (
              <div className="ht-token-border-picker" ref={borderDropdownContainer}>
                <div className="border-tabs herot-border-tabs">
                  <div className={curBorderTab == 'fantasy' ? 'border-tab-default active' : 'border-tab-default'} onClick={() => { setCurBorderTab('fantasy') }}>
                    Fantasy
                  </div>
                  <div className={curBorderTab == 'scifi' ? 'border-tab-default active' : 'border-tab-default'} onClick={() => { setCurBorderTab('scifi') }}>
                    Sci-Fi
                  </div>
                  <div className={curBorderTab == 'horror' ? 'border-tab-default active' : 'border-tab-default'} onClick={() => { setCurBorderTab('horror') }}>
                    Darkness
                  </div>
                  <div className={curBorderTab == 'slim' ? 'border-tab-default active' : 'border-tab-default'} onClick={() => { setCurBorderTab('slim') }}>
                    Simple
                  </div>
                  <div className={curBorderTab == 'custom' ? 'border-tab-default active' : 'border-tab-default'} onClick={() => { setCurBorderTab('custom') }}>
                    Uploaded
                  </div>

                </div>

                {curBorderTab == 'fantasy' && (
                  <div className="ht-token-border-picker-inner" >
                    <input
                      value={borderSearchTerm}
                      placeholder="Search borders..."
                      style={{
                        paddingLeft: "10px",
                      }}
                      onInput={event => setBorderSearchTerm((event.target as HTMLInputElement).value)}
                      className="ht-border-search-input"
                    />


                    <div className="ht-border-search-results">
                      <div className="ht-border-search-free">
                        {borderSearchTerm === '' ? (
                          <div className="ht-pro-border-overlay-preview-container">
                          </div>

                        ) : null}
                      </div>
                      <div className="overlays-grid">
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            if (!overlay.pro) {
                              if (borderSearchTerm) {
                                return overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase());
                              }
                              return overlay.category.includes('fantasy');
                            }
                            return false;
                          })
                          .map((overlay: Overlay, index: number) => {
                            const imgSrc = '/wp-content/heroictoken/borders/' + overlay.image;
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container">
                                <img
                                  className={imgSrc === overlaySrc ? 'ht-border-overlay-active' : 'ht-border-overlay-preview'}
                                  key={index}
                                  src={prevSrc}
                                  onMouseEnter={() => {
                                    setHoverOverlaySrc(imgSrc);
                                    setHoverOffset(overlay.offset);
                                    setHoverHorizontalMovePercentage(overlay.horizontalmove);
                                    setHoverVerticalMovePercentage(overlay.verticalmove);
                                  }}
                                  onMouseLeave={() => {
                                    setHoverOverlaySrc(null);
                                    setHoverOffset(offset);
                                    setHoverHorizontalMovePercentage(null);
                                    setHoverVerticalMovePercentage(null);
                                  }}
                                  onClick={() => {
                                    setOverlaySrc(imgSrc);
                                    setOffset(overlay.offset);
                                    setHorizontalMovePercentage(overlay.horizontalmove);
                                    setVerticalMovePercentage(overlay.verticalmove);
                                    setIsCustomBorder('');
                                  }}
                                />
                              </div>
                            );
                          })}
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            return overlay.pro &&
                              overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase()) &&
                              overlay.category.includes('fantasy');
                          })
                          .map((overlay: Overlay, index: number) => {
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container" key={index}>
                                <img
                                  className={'ht-pro-border-overlay-preview'}
                                  src={prevSrc}
                                />
                                <div className="ht-pro-border-overlay-text">PRO</div>
                              </div>
                            );
                          })}
                      </div>
                      <div className="ht-pro-borders-promo-container">

                      </div>
                      <div style={{ display: 'none' }}>
                        {tokenOverlays.overlays
                          .filter((overlay) => !overlay.pro)
                          .map((overlay) => (
                            <img src={`/wp-content/heroictoken/borders/${overlay.image}`} alt="" key={overlay.image} />
                          ))}
                      </div>
                    </div>
                  </div>
                )}

                {curBorderTab == 'scifi' && (
                  <div className="ht-token-border-picker-inner" >
                    <input
                      value={borderSearchTerm}
                      placeholder="Search borders..."
                      style={{
                        paddingLeft: "10px",
                      }}
                      onInput={event => setBorderSearchTerm((event.target as HTMLInputElement).value)}
                      className="ht-border-search-input"
                    />


                    <div className="ht-border-search-results">
                      <div className="ht-border-search-free">
                        {borderSearchTerm === '' ? (
                          <div className="ht-pro-border-overlay-preview-container">
                          </div>

                        ) : null}
                      </div>
                      <div className="overlays-grid">
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            if (!overlay.pro) {
                              if (borderSearchTerm) {
                                return overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase());
                              }
                              return overlay.category.includes('scifi');
                            }
                            return false;
                          })
                          .map((overlay: Overlay, index: number) => {
                            const imgSrc = '/wp-content/heroictoken/borders/' + overlay.image;
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container">
                                <img
                                  className={imgSrc === overlaySrc ? 'ht-border-overlay-active' : 'ht-border-overlay-preview'}
                                  key={index}
                                  src={prevSrc}
                                  onMouseEnter={() => {
                                    setHoverOverlaySrc(imgSrc);
                                    setHoverOffset(overlay.offset);
                                    setHoverHorizontalMovePercentage(overlay.horizontalmove);
                                    setHoverVerticalMovePercentage(overlay.verticalmove);
                                  }}
                                  onMouseLeave={() => {
                                    setHoverOverlaySrc(null);
                                    setHoverOffset(offset);
                                    setHoverHorizontalMovePercentage(null);
                                    setHoverVerticalMovePercentage(null);
                                  }}
                                  onClick={() => {
                                    setOverlaySrc(imgSrc);
                                    setOffset(overlay.offset);
                                    setHorizontalMovePercentage(overlay.horizontalmove);
                                    setVerticalMovePercentage(overlay.verticalmove);
                                    setIsCustomBorder('');
                                  }}
                                />
                              </div>
                            );
                          })}
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            return overlay.pro &&
                              overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase()) &&
                              overlay.category.includes('scifi');
                          })
                          .map((overlay: Overlay, index: number) => {
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container" key={index}>
                                <img
                                  className={'ht-pro-border-overlay-preview'}
                                  src={prevSrc}
                                />
                                <div className="ht-pro-border-overlay-text">PRO</div>
                              </div>
                            );
                          })}
                      </div>
                      <div className="ht-pro-borders-promo-container">

                      </div>
                      <div style={{ display: 'none' }}>
                        {tokenOverlays.overlays
                          .filter((overlay) => !overlay.pro)
                          .map((overlay) => (
                            <img src={`/wp-content/heroictoken/borders/${overlay.image}`} alt="" key={overlay.image} />
                          ))}
                      </div>
                    </div>
                  </div>
                )}

                {curBorderTab == 'horror' && (
                  <div className="ht-token-border-picker-inner" >
                    <input
                      value={borderSearchTerm}
                      placeholder="Search borders..."
                      style={{
                        paddingLeft: "10px",
                      }}
                      onInput={event => setBorderSearchTerm((event.target as HTMLInputElement).value)}
                      className="ht-border-search-input"
                    />


                    <div className="ht-border-search-results">
                      <div className="ht-border-search-free">
                        {borderSearchTerm === '' ? (
                          <div className="ht-pro-border-overlay-preview-container">
                          </div>

                        ) : null}
                      </div>
                      <div className="overlays-grid">
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            if (!overlay.pro) {
                              if (borderSearchTerm) {
                                return overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase());
                              }
                              return overlay.category.includes('horror');
                            }
                            return false;
                          })
                          .map((overlay: Overlay, index: number) => {
                            const imgSrc = '/wp-content/heroictoken/borders/' + overlay.image;
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container">
                                <img
                                  className={imgSrc === overlaySrc ? 'ht-border-overlay-active' : 'ht-border-overlay-preview'}
                                  key={index}
                                  src={prevSrc}
                                  onMouseEnter={() => {
                                    setHoverOverlaySrc(imgSrc);
                                    setHoverOffset(overlay.offset);
                                    setHoverHorizontalMovePercentage(overlay.horizontalmove);
                                    setHoverVerticalMovePercentage(overlay.verticalmove);
                                  }}
                                  onMouseLeave={() => {
                                    setHoverOverlaySrc(null);
                                    setHoverOffset(offset);
                                    setHoverHorizontalMovePercentage(null);
                                    setHoverVerticalMovePercentage(null);
                                  }}
                                  onClick={() => {
                                    setOverlaySrc(imgSrc);
                                    setOffset(overlay.offset);
                                    setHorizontalMovePercentage(overlay.horizontalmove);
                                    setVerticalMovePercentage(overlay.verticalmove);
                                    setIsCustomBorder('');
                                  }}
                                />
                              </div>
                            );
                          })}
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            return overlay.pro &&
                              overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase()) &&
                              overlay.category.includes('horror');
                          })
                          .map((overlay: Overlay, index: number) => {
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container" key={index}>
                                <img
                                  className={'ht-pro-border-overlay-preview'}
                                  src={prevSrc}
                                />
                                <div className="ht-pro-border-overlay-text">PRO</div>
                              </div>
                            );
                          })}
                      </div>
                      <div className="ht-pro-borders-promo-container">

                      </div>
                      <div style={{ display: 'none' }}>
                        {tokenOverlays.overlays
                          .filter((overlay) => !overlay.pro)
                          .map((overlay) => (
                            <img src={`/wp-content/heroictoken/borders/${overlay.image}`} alt="" key={overlay.image} />
                          ))}
                      </div>
                    </div>
                  </div>
                )}

                {curBorderTab == 'slim' && (
                  <div className="ht-token-border-picker-inner" >
                    <input
                      value={borderSearchTerm}
                      placeholder="Search borders..."
                      style={{
                        paddingLeft: "10px",
                      }}
                      onInput={event => setBorderSearchTerm((event.target as HTMLInputElement).value)}
                      className="ht-border-search-input"
                    />


                    <div className="ht-border-search-results">
                      <div className="ht-border-search-free">
                        {borderSearchTerm === '' ? (
                          <div className="ht-pro-border-overlay-preview-container">
                          </div>

                        ) : null}
                      </div>
                      <div className="overlays-grid">
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            if (!overlay.pro) {
                              if (borderSearchTerm) {
                                return overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase());
                              }
                              return overlay.category.includes('slim');
                            }
                            return false;
                          })
                          .map((overlay: Overlay, index: number) => {
                            const imgSrc = '/wp-content/heroictoken/borders/' + overlay.image;
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container">
                                <img
                                  className={imgSrc === overlaySrc ? 'ht-border-overlay-active' : 'ht-border-overlay-preview'}
                                  key={index}
                                  src={prevSrc}
                                  onMouseEnter={() => {
                                    setHoverOverlaySrc(imgSrc);
                                    setHoverOffset(overlay.offset);
                                    setHoverHorizontalMovePercentage(overlay.horizontalmove);
                                    setHoverVerticalMovePercentage(overlay.verticalmove);
                                  }}
                                  onMouseLeave={() => {
                                    setHoverOverlaySrc(null);
                                    setHoverOffset(offset);
                                    setHoverHorizontalMovePercentage(null);
                                    setHoverVerticalMovePercentage(null);
                                  }}
                                  onClick={() => {
                                    setOverlaySrc(imgSrc);
                                    setOffset(overlay.offset);
                                    setHorizontalMovePercentage(overlay.horizontalmove);
                                    setVerticalMovePercentage(overlay.verticalmove);
                                    setIsCustomBorder('');
                                  }}
                                />
                              </div>
                            );
                          })}
                        {tokenOverlays.overlays
                          .filter((overlay: Overlay) => {
                            return overlay.pro &&
                              overlay.search.toLowerCase().includes(borderSearchTerm.toLowerCase()) &&
                              overlay.category.includes('slim');
                          })
                          .map((overlay: Overlay, index: number) => {
                            const prevSrc = '/wp-content/heroictoken/prev/' + overlay.image;
                            return (
                              <div className="ht-pro-border-overlay-preview-container" key={index}>
                                <img
                                  className={'ht-pro-border-overlay-preview'}
                                  src={prevSrc}
                                />
                                <div className="ht-pro-border-overlay-text">PRO</div>
                              </div>
                            );
                          })}
                      </div>
                      <div className="ht-pro-borders-promo-container">

                      </div>
                      <div style={{ display: 'none' }}>
                        {tokenOverlays.overlays
                          .filter((overlay) => !overlay.pro)
                          .map((overlay) => (
                            <img src={`/wp-content/heroictoken/borders/${overlay.image}`} alt="" key={overlay.image} />
                          ))}
                      </div>
                    </div>
                  </div>
                )}

                {curBorderTab == 'custom' && (
                  <div className="ht-token-border-picker-inner">

                    <div className="herot-crop-controls-headline">
                      <div className="herot-crop-controls-headline-innr">
                        <input type="file" id="uploadborder" onChange={(e) => {
                          onUploadBorder(e);
                        }} />
                        <label id="uploadborder-label" htmlFor="uploadborder" style={{ cursor: 'pointer' }} >
                          <img
                            src="https://heroictoken.com/wp-content/uploads/2024/07/arrow-up-from-bracket-solid.svg"
                            style={{ width: '13px', height: '13px', paddingRight: '4px' }}
                          />
                          Select Border
                        </label>
                        {htPrvImage && (
                          <img className="herot-crop-controls-headline-prv-image"
                            src={htPrvImage}
                          />
                        )}
                        {curUser && (
                          <button id="uploadborder-btn" type="submit" onClick={() => {
                            htUploadBorder(document.getElementById("uploadborder"));

                          }}> Upload </button>
                        )}
                      </div>
                    </div>
                    {borderSaveMsg && (
                      <div className="save-update-message">
                        {borderSaveMsg}
                      </div>
                    )}
                    <div className="herot-crop-controls-headline2">
                      <label id="offset-label" htmlFor="ht-cur-border-offset">
                        Offset:
                      </label>
                      <input value={offset} type="number" id="ht-cur-border-offset" onChange={(e) => { setCurrentOffset(e) }} step="0.02" min="0" max="1" />
                      <label id="move-percentage-label" htmlFor="ht-move-percentage">
                        X:
                      </label>
                      <input
                        value={horizontalMovePercentage}
                        type="number"
                        id="ht-move-percentage"
                        onChange={(e) => setHorizontalMovePercentage(Number(e.target.value))}
                        step="1"
                        min="-100"
                        max="100"
                      />
                      <label id="move-percentage-label" htmlFor="ht-move-percentage">
                        Y:
                      </label>
                      <input
                        value={verticalMovePercentage}
                        type="number"
                        id="ht-move-percentage"
                        onChange={(e) => setVerticalMovePercentage(Number(e.target.value))}
                        step="1"
                        min="-100"
                        max="100"
                      />
                      {curUser && (
                        <button id="updateborder-btn" type="submit" onClick={() => {
                          htUpdateBorderOffset();

                        }}> Save </button>
                      )}
                    </div>

                    {curUser && (
                      <div className="ht-border-search-results-uploaded">
                        <div className="overlays-grid">
                          {borderSearchTerm === '' ? (
                            <img
                              className={overlaySrc === '' ? 'ht-border-overlay-active' : 'ht-border-overlay-preview'}
                              src="/wp-content/heroictoken/borders/noborder.webp"
                              onMouseEnter={() => {
                                setHoverOverlaySrc('/wp-content/heroictoken/borders/transparent.webp');
                                setHoverOffset(1);
                              }}
                              onMouseLeave={() => {
                                setHoverOverlaySrc(null);
                                setHoverOffset(offset);
                              }}
                              onClick={() => {
                                setOverlaySrc('/wp-content/heroictoken/borders/transparent.png');
                                setOffset(1);
                                setIsCustomBorder('');
                              }}
                            />
                          ) : null}
                          {allCustomBorders.map((overlay: any) => {
                            const imgSrc = overlay.fullimg;
                            const prevSrc = overlay.thumbimg;
                            return (
                              <img
                                className={imgSrc === overlaySrc ? 'ht-border-overlay-active' : 'ht-border-overlay-preview'}
                                key={overlay.borderpostid}
                                src={prevSrc}
                                onMouseEnter={() => {
                                  setHoverOverlaySrc(imgSrc);
                                  setHoverOffset(overlay.borderoffset);
                                  setHoverHorizontalMovePercentage(overlay.hrmovepercent);
                                  setHoverVerticalMovePercentage(overlay.vrmovepercent);
                                }}
                                onMouseLeave={() => {
                                  setHoverOverlaySrc(null);
                                  setHoverOffset(offset);
                                  setHoverHorizontalMovePercentage(null);
                                  setHoverVerticalMovePercentage(null);
                                }}
                                onClick={() => {
                                  setOverlaySrc(imgSrc);
                                  setOffset(overlay.borderoffset);
                                  setIsCustomBorder('yes');
                                  setCurrentBorderId(overlay.borderpostid);
                                  setHorizontalMovePercentage(overlay.hrmovepercent);
                                  setVerticalMovePercentage(overlay.vrmovepercent);
                                }}
                              />
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {curBorderTab == 'custom' && !curUser && (
                  <div className="ht-token-border-picker-inner">
                    Signup for free to save your own custom borders on our server. <a href="https://heroictoken.com/join/" target="_blank">Join now</a>
                  </div>
                )}

              </div>
            )}

          </div>
          <div className="herot-border-button-container">
            <div className="herot-app-header-button" onClick={() => {
              setOpenDropdown(null);
            }} style={{ position: 'relative', display: 'inline-block' }}> {/* Ensure this div is positioned relatively and has display inline-block */}
              <img
                src="/wp-content/heroictoken/icons/paint-roller-solid.svg"
                style={{ width: '20px', height: '20px', padding: '2px', marginTop: '5px' }}
              />
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* Invisible input covering the button */}
                <input
                  ref={backgroundColorInputRef}
                  type="color"
                  style={{
                    opacity: 0, // Keep it invisible
                    position: 'absolute',
                    zIndex: 2,
                    width: '100%', // Extend to cover the entire div
                    height: '100%', // Extend to cover the entire div
                    cursor: 'pointer', // Change cursor to indicate clickable area
                  }}
                  value={backgroundColor}
                  onChange={(event) => setBackgroundColor(event.target.value)}
                />
              </div>
              <div>Background</div>
            </div>
            {openDropdown === 'color' && (
              <div className="ht-token-color-picker" ref={colorDropdownContainer}>
                <div className="herot-crop-controls-headline">
                  <div><img
                    src="/wp-content/heroictoken/icons/paint-roller-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Background Color</div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <input
                    type="color"
                    value={backgroundColor}
                    onChange={(event) => setBackgroundColor(event.target.value)}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="herot-border-button-container">
            <div className="herot-app-header-button" onClick={() => {
              if (isMobile) {
                setTimeout(() => setOpenDropdown(openDropdown === 'zoom' ? null : 'zoom'), 0);
                setOpenDropdown(null);
              } else {
                setOpenDropdown(null);
              }
            }}>
              {isMobile ? (
                // If it's mobile, show an SVG instead of the input
                <div>
                  <img
                    src="/wp-content/heroictoken/icons/magnifying-glass-solid.svg"
                    style={{ width: '22px', height: '22px', padding: '2px' }}
                  />
                </div>
              ) : (
                // For non-mobile devices, show the input field
                <div>
                  <input
                    type="number"
                    style={{ width: '50px', height: '23px', margin: '2px', padding: '0px 0px 0px 6px' }}
                    min="0.5"
                    max="1"
                    step="0.1"
                    value={scale.toString()}
                    onChange={(e) => setScale(parseFloat(e.target.value))}
                    alt="Magnifier symbol"
                  />
                </div>
              )}
              <div>Zoom</div>
            </div>
            {openDropdown === 'zoom' && (
              <div className="ht-token-zoom" ref={zoomDropdownContainer} >

                <div className="herot-crop-controls-headline">
                  <div><img
                    src="/wp-content/heroictoken/icons/magnifying-glass-minus-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Zoom Out</div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label style={{ cursor: 'pointer' }}>
                    <input
                      type="range"
                      min="0.5"
                      max="1"
                      step="0.1"
                      value={scale}
                      onChange={(e) => setScale(parseFloat(e.currentTarget.value))}
                    />
                    Scale: {scale}
                  </label>
                </div>
              </div>
            )}

          </div>
          <div className="herot-border-button-container">
            <div className="herot-app-header-button" onClick={() => {
              setOpenDropdown(null);
              setTimeout(() => setOpenDropdown(openDropdown === 'settings' ? null : 'settings'), 0);
            }}>
              <div><img
                src="/wp-content/heroictoken/icons/hammer-solid.svg"
                style={{
                  width: '20px', height: '20px', padding: '2px'
                }}
                alt="gear symbol"
              /></div>
              <div>Tools</div>

            </div>
            {openDropdown === 'settings' && (
              <div className="ht-token-settings" ref={settingsDropdownContainer} >
                <div className="herot-crop-controls-headline">
                  <div><img
                    src="/wp-content/heroictoken/icons/feather-pointed-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Token name</div>
                </div>
                <div style={{ width: "100%" }}>
                  <input
                    type="text"
                    value={tokenName}
                    onChange={(e) => setTokenName(e.target.value)}
                    style={{ width: '95%', height: '25px', marginBottom: '10px' }}
                  />
                </div>
                <div>
                  <div className="herot-crop-controls-headline"><img
                    src="/wp-content/heroictoken/icons/maximize-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Token size</div>
                  <div className="ht-token-size-picker">
                    <label style={{ cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        value="200"
                        checked={tokenSize === 200}
                        onChange={(e) => setTokenSize(Number(e.target.value))}
                      />
                      200px
                    </label>
                    <label style={{ cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        value="300"
                        checked={tokenSize === 300}
                        onChange={(e) => setTokenSize(Number(e.target.value))}
                      />
                      300px
                    </label>
                    <label style={{ cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        value="400"
                        checked={tokenSize === 400}
                        onChange={(e) => setTokenSize(Number(e.target.value))}

                      />
                      400px
                    </label>
                    <label style={{ cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        value="600"
                        checked={tokenSize === 600}
                        onChange={(e) => setTokenSize(Number(e.target.value))}

                      />
                      600px
                    </label>
                  </div>
                </div>

                <div className="herot-crop-controls-headline">
                  <div><img
                    src="/wp-content/heroictoken/icons/border-none-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Grid</div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label style={{ cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={ruleOfThirds}
                      onClick={(e) => setRuleOfThirds(e.currentTarget.checked)}
                    />
                    Show Rule of Thirds
                  </label>
                </div>


                <div className="herot-crop-controls-headline">
                  <div><img
                    src="/wp-content/heroictoken/icons/filter-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Overlay Filter</div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={herotFilterActive}
                      onChange={() => setHerotFilterActive(!herotFilterActive)}
                    />
                    Filter Active
                  </label>
                </div>
                <div className="herot-crop-controls-headline">

                  <div><img
                    src="/wp-content/heroictoken/icons/fill-drip-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Overlay Color Opacity</div>
                </div>
                <div>Opacity: {herotFilterTransp}</div>
                <div style={{ marginBottom: '10px' }}>
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={herotFilterTransp}
                    onChange={(event) => {
                      setHerotFilterTransp(parseFloat(event.target.value));
                    }}
                  />
                </div>

                <div className="herot-crop-controls-headline">
                  <div><img
                    src="/wp-content/heroictoken/icons/fill-drip-solid.svg"
                    style={{ width: '16px', height: '16px', paddingRight: '5px' }}
                  />
                    Overlay Color</div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <input
                    type="color"
                    value={`#${((1 << 24) + (herotFilterColor.r << 16) + (herotFilterColor.g << 8) + herotFilterColor.b).toString(16).slice(1)}`}
                    onChange={(event) => {
                      const rgb = parseInt(event.target.value.slice(1), 16);
                      const r = (rgb >> 16) & 255;
                      const g = (rgb >> 8) & 255;
                      const b = rgb & 255;
                      setHerotFilterColor({ r, g, b });
                      setHerotFilterActive(true);
                    }}
                  />
                </div>

              </div>
            )}
          </div>


          <div className="herot-signup-top-container">
            <a href="https://heroictoken.com/join/" target="_blank">
              {!curUser ? (
                <div className="herot-signup-top-cont-container">
                  <div className="herot-signup-top-text" id="herotsignupfreetext">Get Lifetime PRO & Use all 282 borders</div>
                  <div className="herot-signup-top-button"><a href="https://heroictoken.com/join/" target="_blank">Sign up now</a></div>
                </div>
              ) : (
                <div className="herot-signup-top-cont-container">
                  <div className="herot-signup-top-text" id="herotgoprotext">Get Lifetime PRO & Use all 282 borders</div>
                  <div className="herot-signup-top-button"><a href="https://heroictoken.com/join/" target="_blank">Learn more</a></div>
                </div>
              )}
            </a>
          </div>
        </div>



        <div className="herot-crop-container" style={{ position: 'relative', backgroundColor: 'grey' }}>
          {imgSrc && hoverOverlaySrc !== '' && (hoverOverlaySrc || overlaySrc) && (overlayImageUrl !== null) && (
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: backgroundColor }}>
              <img
                src={overlayImageUrl}
                style={{
                  position: 'absolute',
                  top: `${cropPosition.y}px`,
                  left: `${cropPosition.x}px`,
                  width: `${cropSize.width}px`,
                  height: `${cropSize.height}px`,
                  objectFit: 'cover',
                  pointerEvents: 'none',
                  zIndex: 4
                }}
              />
            </div>
          )}
          {!!imgSrc ? (
            <ReactCrop
              crop={crop}
              onChange={(c, percentCrop) => {
                setCrop(percentCrop);
                setCompletedCrop(c);
              }}
              onComplete={(c) => setCompletedCrop(c)}
              aspect={aspect}
              minWidth={100}
              minHeight={100}
              circularCrop
              keepSelection
              ruleOfThirds={ruleOfThirds}
            >

              {/* Image on the main canvas */}
              <img
                ref={imgRef}
                alt="Crop me"
                src={imgSrc}
                style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                onLoad={onImageLoad}
              />


            </ReactCrop>
          ) : (
            <div className="ht-upload-image-background-container">
              <input
                type="file"
                id="imageUpload"
                style={{ display: 'none' }}
                accept="image/*"
                onChange={(e) => {
                  onSelectFile(e);
                  setOverlaySrc(overlaySrc);
                }}
                disabled={htLoadingScreen}
              />
              <label htmlFor="imageUpload">
                <div className="ht-upload-image-background">
                  <div style={{ textAlign: 'center' }}>
                    <img
                      className={htLoadingScreen ? 'spinning' : ''}
                      src={htLoadingScreen ? "/wp-content/heroictoken/icons/spinner-solid.svg" : "/wp-content/heroictoken/icons/upload-solid.svg"}
                      style={{ width: '30px', height: '30px' }}
                    />
                  </div>
                  <div>
                    {htLoadingScreen ? "Image is being opened..." : "Click to upload an image"}
                  </div>
                </div>
              </label>
            </div>
          )}
        </div>
      </div>


      <>
        <div className="herot-preview-bar">
          <div className="herot-preview-container-container">
            <div
              className="herot-preview-container"
            >
              {!!completedCrop && (
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    objectFit: "contain",
                    width: `${percentCrop}px`,
                    minWidth: '300px',
                    height: `${percentCrop}px`,
                    minHeight: '300px',
                    maxWidth: "100%",
                  }}
                />
              )}
            </div>
          </div>

          <div className="herot-sidebar" >

            <div className="herot-crop-controls-button-50">
              <label htmlFor="fileUpload" className="herot-customFileUpload" style={{ cursor: 'pointer' }}>
                <div><img
                  src="/wp-content/heroictoken/icons/upload-solid.svg"
                  style={{ width: '20px', height: '20px', padding: '2px' }}
                  alt="upload symbol"
                /></div>
                <div>Upload</div>
              </label>
              <input type="file" id="fileUpload" accept="image/*" onChange={onSelectFile} style={{ display: 'none' }} />
            </div>
            <div className="herot-crop-controls-button-50" onClick={() => {
              viewMainSitePopUp(); // Shomen
            }}>
              <div>
                <img
                  src="/wp-content/heroictoken/icons/folder-open-solid.svg"
                  style={{ width: '20px', height: '20px', padding: '2px' }}
                  alt="open folder symbol"
                />
              </div>
              <div>Library</div>
            </div>


            <div
              className="herot-crop-controls-button-50"
              onClick={crop ? onDownloadCropClick : undefined}
            >
              <div><img
                src="/wp-content/heroictoken/icons/download-solid.svg"
                style={{ width: '20px', height: '20px', padding: '2px' }}
                alt="download symbol"
              /></div>
              <div>Download</div>
            </div>

            {!curUser ? (
              <div></div>
            ) : (
              <div className={`herot-crop-controls-button-50 ${isSaveButtonDisabled ? 'ht-waiting' : ''}`}
                onClick={() => {
                  if (!curUser) {
                    openRegisterPopup();
                  } else if (!isSaveButtonDisabled) {
                    saveCroppedImage(); // Shomen
                    setSaveButtonDisabled(true);
                    setTimeout(() => setSaveButtonDisabled(false), 5000);
                  }
                }}
              >
                <div>
                  <img
                    className={isSaveButtonDisabled ? 'spinning' : ''}
                    src={isSaveButtonDisabled ? "/wp-content/heroictoken/icons/spinner-solid.svg" : "/wp-content/heroictoken/icons/floppy-disk-solid.svg"}
                    style={{ width: '20px', height: '20px', padding: '2px' }}
                    alt="save disk symbol"
                  />
                </div>
                <div>{isSaveButtonDisabled ? "Saving..." : "Save"}</div>
              </div>
            )}

            <a
              href="#hidden"
              ref={hiddenAnchorRef}
              download
              style={{
                position: "absolute",
                top: "-200vh",
                visibility: "hidden",
              }}
            >
              Hidden download
            </a>

          </div>


        </div>

      </>

      {
        isGoProPopupOpen && (
          <div className="item-popup-overlay" >
            <div className="herot-gopro-popup" ref={popupRef}>
              <div className="herot-gopro-popup-content">
                <div className="herot-gopro-popup-h"><img
                  src="/wp-content/heroictoken/icons/dragon-solid.svg"
                  style={{ width: '25px', height: '25px', paddingRight: '9px' }}
                /> Loot the Dragon's Hoard</div>
                <div className="herot-gopro-popup-benefits-container">
                  <div className="herot-gopro-popup-subh">Level up to PRO and enjoy these features:</div>
                  <div className="herot-gopro-popup-benefits">
                    <div className="herot-gopro-popup-benefit">Save your tokens & sources online</div>
                    <div className="herot-gopro-popup-benefit">Use all free and PRO borders</div>
                    <div className="herot-gopro-popup-benefit">Remove ads</div>
                  </div>
                </div>
                <div className="herot-gopro-popup-bttn-container">
                  <a href="https://heroictoken.com/join/" target="_blank"><div className="herot-gopro-popup-bttn">
                    <div className="herot-gopro-popup-bttn-top">Learn more</div>
                    <div className="herot-gopro-popup-bttn-bottom">(Opens in a new tab)</div>
                  </div></a>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isRegisterPopupOpen && (
          <div className="item-popup-overlay">
            <div className="herot-gopro-popup" ref={popupRef}>
              <div className="herot-gopro-popup-content">
                <div className="herot-gopro-popup-h"><img
                  src="/wp-content/heroictoken/icons/shield-solid.svg"
                  style={{ width: '25px', height: '25px', paddingRight: '9px' }}
                />Join the Guild<img
                    src="/wp-content/heroictoken/icons/shield-solid.svg"
                    style={{ width: '25px', height: '25px', paddingLeft: '9px' }}
                  /></div>
                <div className="herot-gopro-popup-benefits-container">
                  <div className="herot-gopro-popup-subh">Sign up for free and enjoy these features:</div>
                  <div className="herot-gopro-popup-benefits">
                    <div className="herot-gopro-popup-benefit">Save your tokens online</div>
                    <div className="herot-gopro-popup-benefit">Store your source files online</div>
                  </div>
                </div>
                <div className="herot-gopro-popup-bttn-container">
                  <a href="https://heroictoken.com/join/" target="_blank"><div className="herot-gopro-popup-bttn">
                    <div className="herot-gopro-popup-bttn-top">Learn more</div>
                    <div className="herot-gopro-popup-bttn-bottom">(Opens in a new tab)</div>
                  </div></a>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
}
